// Main menu hover
$(".tt-main-menu-list").on("mouseenter", function () {
    $(this).addClass("tt-mm-hover");
}).on("mouseleave", function () {
    $(this).removeClass("tt-mm-hover");
});

// Submenu wrap hover
$(".submenu-mega").on("mouseenter", function () {
    $(this).addClass("submenu-open");
}).on("mouseleave", function () {
    $(this).removeClass("submenu-open");
});


// ==================================
// Shop sliding cart
// ==================================

if ($(".tt-sliding-cart-wrap").length) {

    // Append shop sliding cart
    $(".tt-sliding-cart-wrap").appendTo("#body-inner");

    // Open shop sliding cart
    $(".tt-sliding-cart-trigger").on("click", function() {
        $("body").toggleClass("tt-sliding-cart-open");
    });

    // Close shop sliding cart
    $(".tt-sliding-cart-cover, .tt-sliding-cart-close, .tt-sliding-cart a")
    .not('[target="_blank"]') // omit from selection
    .not('[href^="#"]') // omit from selection
    .not(".tt-sc-product-remove") // omit from selection
    .on("click", function() {
        $("body").removeClass("tt-sliding-cart-open");
    });
}

// ==================================
	// tt-Search
	// ==================================

	if ($(".tt-search").length) {

		// Append tt-Search
		$(".tt-search").appendTo("#body-inner");

		// Open tt-Search
		$(".tt-search-trigger").on("click", function () {
			$("body").addClass("tt-search-open");
			var tl_ttSearchIn = gsap.timeline();
			tl_ttSearchIn.to(".tt-search", {
				duration: 0.4,
				autoAlpha: 1
			});
			tl_ttSearchIn.from(".tt-search-appear", {
				duration: 0.5,
				y: 80,
				autoAlpha: 0,
				stagger: 0.1,
				ease: Power2.easeOut,
				clearProps: "all"
			}, "+=0.1");
		});

		// Close tt-Search
		$(".tt-search-close, .tt-search-close-btn").on("click", function () {
			$("body").removeClass("tt-search-open");
			var tl_ttSearchOut = gsap.timeline();
			tl_ttSearchOut.to(".tt-search-appear", {
				duration: 0.5,
				y: -80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeIn
			});
			tl_ttSearchOut.to(".tt-search", {
				duration: 0.4,
				autoAlpha: 0,
				clearProps: "all"
			}, "+=0.2");
			tl_ttSearchOut.to(".tt-search-appear", {
				clearProps: "all"
			});
		});
	}

	if ($(".search-box").length) {

		

		// Open tt-Search
		$(".tt-search-trigger").on("click", function () {
			$("body").toggleClass("tt-search-open");
			$( ".search-box input" ).focus();
			$('.tt-search-trigger-icon .fa-search, .tt-search-trigger-icon .fa-times').toggleClass('fa-search fa-times')
		});
	}

    $(document).ready(function () {
        $('.site-link').meanmenu({
            meanMenuContainer: '.mobile-menu',
            meanScreenWidth: "991",
            // meanExpand: ['<i class="fal fa-plus"></i>'],
        });
    });

    $('#menu-btn').on('click', function () {
        $('.menu-mobile-container').addClass('open')
        $('.body-overlay').addClass('opened')
    })
    

    $(".mobile__close-btn").on('click', function () {
        $('.menu-mobile-container').removeClass('open')
        $('.body-overlay').removeClass('opened')
    })
    
    $(".body-overlay").on('click', function () {
        $('.menu-mobile-container').removeClass('open');
        $('.cart-container').removeClass('open');
        $(this).removeClass('opened');
    })
    
    $('.cart-btn').on('click', function () {
        $('.cart-container').addClass('open')
        $('.body-overlay').addClass('opened')
    })
    
    $(".cart-close").on('click', function () {
        $('.cart-container').removeClass('open')
        $('.body-overlay').removeClass('opened')
    })
    
    $("#search-icon").on('click', function () {
        $('.search-box-form').addClass('open')
    })
    
    $('.close-search').on('click', function () {
        $('.search-box-form').removeClass('open')
    })

    //Swiper Slider For Shop
    var swiper = new Swiper(".product-gallary-thumb", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".product-gallary", {
        spaceBetween: 10,
        loop: true,
        navigation: {
            nextEl: ".swiper-nav-next",
            prevEl: ".swiper-nav-prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });

	var swiperBanner = new Swiper($('.banner-slide').find(".swiper")[0], {
		effect: "coverflow",
		grabCursor: true,
		centeredSlides: true,
		slidesPerView: 1.4,
		spaceBetween: 0,
		// freeMode: true,
	
		coverflowEffect: {
			rotate: 10,
			stretch: 0,
			depth: 100,
			modifier: 2.95,
			slideShadows: true,
		},
		navigation: {
			nextEl: $('.banner-slide').find(".slide-arrow-next")[0],
			prevEl: $('.banner-slide').find(".slide-arrow-prev")[0],
			disabledClass: "slide-arrow-disabled",
		},
		breakpoints: {
			
			1200: {
				slidesPerView: 2.5,
			},
			992: {
				slidesPerView: 2.5,
			},
			560: {
				slidesPerView: 1.3,
			}
		},
	})

    // Shop single product quantity (plus/minus button)
	// =============================

	$(".qtybutton").on("click", function() {
		var $qtyButton = $(this);
		var oldValue = $qtyButton.parent().find("input").val();
		if ($qtyButton.text() == "+") {
			var newVal = parseFloat(oldValue) + 1;
		} else {
			if (oldValue > 1) {
				var newVal = parseFloat(oldValue) - 1;
			} else {
				newVal = 1;
			}
		}
		$qtyButton.parent().find("input").val(newVal);
	});


    if ($(".tt-product-carousel").length) {
		$(".tt-product-carousel").each(function() {
			var $ttProductCarousel = $(this);

			// Data attributes
			// ================
			var $dataSimulateTouch = $ttProductCarousel.data("simulate-touch");
			var $dataLoop = $ttProductCarousel.data("loop") ? { loopedSlides: 100, } : $ttProductCarousel.data("loop");
			var $dataAutoplay = $ttProductCarousel.data("autoplay") ? { delay: $ttProductCarousel.data("autoplay"), } : $ttProductCarousel.data("autoplay");

			if ($ttProductCarousel.is("[data-slides-per-view]")) {
				var $dataSlidesPerView = $ttProductCarousel.data("slides-per-view");
			} else {
				var $dataSlidesPerView = 4; // by default
			}

			if ($ttProductCarousel.is("[data-space-between]")) {
				var $dataSpaceBetween = $ttProductCarousel.data("space-between");
			} else {
				var $dataSpaceBetween = 0; // by default
			}

			if ($ttProductCarousel.is("[data-speed]")) {
				var $dataSpeed = $ttProductCarousel.data("speed");
			} else {
				var $dataSpeed = 800; // by default
			}

			// Init Swiper
			// =============
			var $ttProductCarouselSwiper = new Swiper($ttProductCarousel.find(".swiper")[0], {
				slidesPerView: 1,
				slidesPerGroup: 1,
				preloadImages: false, // Needed for lazy loading
				watchSlidesProgress: true, // Needed for lazy loading (if slidesPerView is "auto" or more than 1)
				speed: $dataSpeed,
				resistanceRatio: 0.85,
				longSwipesRatio: 0.2,
				shortSwipes: true,
				lazy: true,
				spaceBetween: $dataSpaceBetween,
				loop: $dataLoop,
				autoplay: $dataAutoplay,
				simulateTouch: $dataSimulateTouch,
				grabCursor: $dataSimulateTouch,

				navigation: {
					nextEl: $ttProductCarousel.find(".tt-prc-arrow-next")[0],
					prevEl: $ttProductCarousel.find(".tt-prc-arrow-prev")[0],
					disabledClass: "tt-prc-arrow-disabled",
				},

				breakpoints: {
					// When window width is 1200px or larger
					1200: {
						slidesPerView: $dataSlidesPerView,
					},
					// When window width is 992px or larger
					992: {
						slidesPerView: 3,
					},
					// When window width is 560px or larger
					560: {
						slidesPerView: 2,
					}
				},
			});

		});

	}